import gql from 'graphql-tag';

const rejectFlatRateOfferBatchMutation = gql`
  mutation rejectFlatRateOfferBatch($input: RejectFlatRateOfferBatchInput!) {
    rejectFlatRateOfferBatch(input: $input) {
      success
      errors
    }
  }
`;

export default rejectFlatRateOfferBatchMutation;
